const defaultFilterOptions = {
  machine_type: 'All',
  software_type: 'All',
  software_version_name: '',
};

export default defaultFilterOptions;
